<main>
  <div
    class="flex flex-column flex-wrap align-content-center align-items-center justify-content-center w-12"
    [ngClass]="{ 'non-scrollable': isExistingValidationWindowOpen }"
  >
    @if ((authService.authenticated | async) === false) {
      <div
        class="flex flex-column w-12 alert py-2 mb-2 text-center align-content-center justify-content-center"
      >
        <p class="pt-2">
          You are not logged in. You can check validation options, but cannot
          start a validation.
          <a
            (click)="authService.switchLoginModal(true)"
            class="mt-5 cursor-pointer"
            >Click here</a
          >
          to log in or use
          <a [routerLink]="'/signup'" class="mt-5">this form</a> to register.
        </p>
      </div>
    }

    <div
      class="flex flex-column flex-wrap xl:w-8 lg:w-9 w-10 justify-content-center align-content-center"
    >
      @if (!maintenanceMode) {
        <div
          class="flex flex-column flex-wrap align-content-center justify-content-center flex-wrap"
        >
          <div
            class="flex flex-row gap-3 justify-content-center w-10 p-2 flex-wrap lg:flex-nowrap"
          >
            <!--  data column-->
            <div class="flex flex-column lg:w-6 w-12">
              <!--        here toggleable is set to false, otherwise accordions won't close, that's a bug in primeng 15.4.1-->
              <p-panel
                header="Datasets"
                [toggleable]="false"
                class="validation-small-row"
              >
                <ng-template pTemplate="icons">
                  <label
                    class="p-panel-header-icon"
                    pTooltip="The soil moisture dataset which is to be validated, i.e. compared to the 'Reference' data."
                    tooltipPosition="bottom"
                  >
                    <span class="pi pi-question-circle"></span>
                  </label>
                </ng-template>
                <!-- If you want the last panel opened by default when multiple=true, pass an array with that value -->
                <p-accordion
                  [multiple]="true"
                  [value]="[
                    validationModel.datasetConfigurations.length - 1 + '',
                  ]"
                >
                  @for (
                    item of validationModel.datasetConfigurations;
                    track item;
                    let datasetIdx = $index
                  ) {
                    <p-accordion-panel
                      [value]="datasetIdx + ''"
                      [ngClass]="{
                        highlighted: (item.highlighted$ | async),
                        'is-reference':
                          (item.spatialReference$ | async) ||
                          (item.temporalReference$ | async) ||
                          (item.scalingReference$ | async),
                      }"
                    >
                      <p-accordion-header>
                        {{ item.datasetModel.selectedDataset?.pretty_name }} /
                        {{ item.datasetModel.selectedVersion?.pretty_name }} /
                        {{ item.datasetModel.selectedVariable?.short_name }}
                        {{
                          validationConfigService.getInformationOnTheReference(
                            item.spatialReference$ | async,
                            item.temporalReference$ | async,
                            item.scalingReference$ | async
                          )
                        }}
                      </p-accordion-header>
                      <p-accordion-content>
                        <!-- your previous tab content goes here -->
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .datasetModel.selectedDataset &&
                          validationModel.datasetConfigurations[datasetIdx]
                            .datasetModel.selectedVersion
                        ) {
                          <qa-dataset
                            [selectionModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [removable]="true"
                            (changeDataset)="onDatasetChange($event)"
                          />
                        }
                        @for (
                          filter of item.basicFilters;
                          track filter;
                          let filterIdx = $index
                        ) {
                          <qa-basic-filter
                            [ngClass]="{
                              'ml-1-icon': isIncluded(
                                filter.filterDto.id,
                                item.basicFilters
                              ),
                            }"
                            [isIncluded]="
                              isIncluded(filter.filterDto.id, item.basicFilters)
                            "
                            [filterModel]="filter"
                            (excludeMutual)="
                              includeFilter($event, item.basicFilters, false)
                            "
                            (includeMutual)="
                              includeFilter(
                                $event,
                                item.basicFilters,
                                filter.enabled
                              )
                            "
                            (updateMap)="onBasicFilterMapUpdate($event)"
                          />
                        }
                        @if (
                          (validationModel.datasetConfigurations[datasetIdx]
                            .smosRfiFilter$ | async) ||
                          (validationModel.datasetConfigurations[datasetIdx]
                            .smosChi2Filter$ | async) ||
                          (validationModel.datasetConfigurations[datasetIdx]
                            .vegetationWaterFilter$ | async) ||
                          (validationModel.datasetConfigurations[datasetIdx]
                            .staticWaterFilter$ | async) ||
                          (validationModel.datasetConfigurations[datasetIdx]
                            .filAscatSsmSensitivityFilter$ | async) ||
                          (validationModel.datasetConfigurations[datasetIdx]
                            .filAscatsspFilter$ | async)
                        ) {
                          <hr />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .smosRfiFilter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .smosRfiFilter$
                            "
                            [minThreshold]="0"
                            [increment]="0.05"
                            [maxThreshold]="1.0"
                            [units]="' [-]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .smosChi2Filter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .smosChi2Filter$
                            "
                            [minThreshold]="0"
                            [increment]="0.05"
                            [maxThreshold]="1.0"
                            [units]="' [-]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .vegetationWaterFilter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .vegetationWaterFilter$
                            "
                            [minThreshold]="0"
                            [increment]="1"
                            [maxThreshold]="60"
                            [units]="' [kg/m3]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .staticWaterFilter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .staticWaterFilter$
                            "
                            [minThreshold]="0"
                            [increment]="0.05"
                            [maxThreshold]="1.0"
                            [units]="' [-]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .filAscatSsmSensitivityFilter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .filAscatSsmSensitivityFilter$
                            "
                            [minThreshold]="0"
                            [increment]="0.01"
                            [maxThreshold]="200"
                            [units]="' [dB]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .filAscatsspFilter$ | async
                        ) {
                          <qa-threshold-filter
                            [datasetModel]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .datasetModel
                            "
                            [filterModel$]="
                              validationModel.datasetConfigurations[datasetIdx]
                                .filAscatsspFilter$
                            "
                            [minThreshold]="0"
                            [increment]="0.01"
                            [maxThreshold]="100"
                            [units]="' [%]'"
                          />
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .ismnNetworkFilter$ | async
                        ) {
                          <div>
                            <qa-ismn-network-filter
                              (networkSelectionChanged)="
                                onIsmnNetworkSelectionChange($event)
                              "
                              [datasetModel]="
                                validationModel.datasetConfigurations[
                                  datasetIdx
                                ].datasetModel
                              "
                              [filterModel$]="
                                validationModel.datasetConfigurations[
                                  datasetIdx
                                ].ismnNetworkFilter$
                              "
                            />
                          </div>
                        }
                        @if (
                          validationModel.datasetConfigurations[datasetIdx]
                            .ismnDepthFilter$ | async
                        ) {
                          <div>
                            <qa-ismn-depth-filter
                              (depthSelectionChanged)="
                                onIsmnDepthSelectionChange($event)
                              "
                              [datasetModel]="
                                validationModel.datasetConfigurations[
                                  datasetIdx
                                ].datasetModel
                              "
                              [filterModel$]="
                                validationModel.datasetConfigurations[
                                  datasetIdx
                                ].ismnDepthFilter$
                              "
                            />
                          </div>
                        }
                        <div style="width: 100%; text-align: right">
                          <button
                            pButton
                            type="button"
                            [disabled]="
                              validationModel.datasetConfigurations.length < 3
                            "
                            (click)="
                              removeDataset(
                                validationModel.datasetConfigurations[
                                  datasetIdx
                                ]
                              )
                            "
                            label="Remove dataset"
                            icon="pi pi-trash"
                            class="p-button-danger"
                          ></button>
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }
                </p-accordion>
                <button
                  pButton
                  type="button"
                  label="Add dataset"
                  icon="pi pi-plus-circle"
                  (click)="addDatasetToValidate()"
                  class="p-button"
                  [disabled]="addDatasetButtonDisabled()"
                ></button>
              </p-panel>
            </div>
            <div class="flex flex-column lg:w-6 w-12 gap-2">
              <!--  reference column-->
              <p-panel
                header="Reference"
                [toggleable]="false"
                class="validation-small-row"
              >
                <ng-template pTemplate="icons">
                  <label
                    class="p-panel-header-icon"
                    pTooltip="Select which dataset chosen in the 'Data' component should be marked as spatial and temporal reference."
                    tooltipPosition="bottom"
                  >
                    <span class="pi pi-question-circle"></span>
                  </label>
                </ng-template>
                <!--spatial reference-->
                <div class="mt-4">
                  <span><b>Spatial reference</b></span>
                  <span
                    class="pi pi-question-circle ml-2"
                    pTooltip="Choose the spatial reference dataset. If the ISMN dataset belongs to the dataset pool,
                      it has to be chosen as the spatial reference. Due to technical limitations, we cannot guarantee that
                      using user data as the spatial reference will always produce results. Therefore, we recommend using one
                      of the datasets provided in the app."
                    tooltipPosition="bottom"
                  >
                  </span>
                </div>
                <qa-validation-reference
                  id="spatial-reference"
                  #spatialReference
                  [validationModel]="validationModel"
                  [referenceType]="'spatialReference$'"
                  (hoverOverDataset)="onHoverOverReferenceDataset($event)"
                />
                <p-divider styleClass="my-3 opacity-50"></p-divider>
                <!--temporal reference-->
                <div>
                  <span><b>Temporal reference</b></span>
                  <span
                    class="pi pi-question-circle ml-2"
                    pTooltip="Choose the temporal reference dataset. ISMN is not recommended."
                    tooltipPosition="bottom"
                  >
                  </span>
                </div>
                <qa-validation-reference
                  id="temporal-reference"
                  #temporalReference
                  [validationModel]="validationModel"
                  [referenceType]="'temporalReference$'"
                  (hoverOverDataset)="onHoverOverReferenceDataset($event)"
                />
                <!--      Temporal matching-->
                <div class="mt-2">
                  <span><b>Temporal matching window</b></span>
                  <span
                    class="pi pi-question-circle ml-2"
                    pTooltip="Select the size of the temporal matching window used to collocate the 'reference' and 'data' measurements in time.
                                  The specified temporal window is centered on the reference measurements (i.e., with edges at +- half size distance from each considered measurement point).
                                  NOTE: the size of the window influences the number of observations used in the validation and could lead to no results in case no matches are found."
                    tooltipPosition="bottom"
                  >
                  </span>
                </div>
                <qa-temporal-matching
                  id="temporal-matching"
                  [temporalMatchingModel]="
                    validationModel.temporalMatchingModel
                  "
                />
              </p-panel>
              <!--      Scaling-->
              <qa-scaling
                [validationModel]="validationModel"
                (hoverOverDataset)="onHoverOverReferenceDataset($event)"
              />
            </div>
          </div>
          <!--      Map-->
          <div class="w-10 p-2">
            <qa-map
              class="map"
              #qwerty
              [spatialSubset]="validationModel.spatialSubsetModel"
              [center]="[10, 52.5]"
              [zoom]="2.5"
              (noIsmnPoints)="checkIsmnPoints($event)"
            />
          </div>
          <!--      Spatial subsetting-->
          <div class="w-10 p-2">
            <qa-spatial-subset
              [subsetModel]="validationModel.spatialSubsetModel"
            />
          </div>
          <!--      Temporal subsetting-->
          <div class="w-10 p-2">
            <qa-validation-period
              [validationPeriodModel]="validationModel.validationPeriodModel"
            />
          </div>
          <!--      Metrics-->
          <div class="w-10 p-2">
            <qa-metrics [(validationModel)]="validationModel" />
          </div>
          <!--      Anomalies-->
          <div class="w-10 p-2">
            <qa-anomalies [anomaliesModel]="validationModel.anomalies" />
          </div>
          <!-- Name -->
          <div class="w-10 p-4 flex align-items-center gap-2">
            <div class="flex-grow-1">
              <p-floatLabel>
                <input
                  maxlength="80"
                  class="form-field w-full"
                  id="name"
                  type="text"
                  pInputText
                  [ngModel]="validationModel.nameTag$ | async"
                  (ngModelChange)="validationModel.nameTag$.next($event)"
                />
                <label for="name">Validation name</label>
              </p-floatLabel>
            </div>
            <span
              pTooltip="Optional name for this validation (max 80 characters)."
              class="pi pi-question-circle help-field"
            >
            </span>
          </div>
          <!-- Button -->
          <div class="w-10 p-2">
            <div class="flex flex-row flex-wrap justify-content-center">
              <span
                pTooltip="{{
                  disableValidateButton(validationModel)
                    ? (validationDisabledMessage | async)
                    : ''
                }}"
              >
                <p-button
                  id="validateButton"
                  label="Validate"
                  icon="pi pi-play"
                  [disabled]="disableValidateButton(validationModel)"
                  (onClick)="startValidation(true)"
                >
                </p-button>
              </span>
            </div>
          </div>
        </div>
      }

      @if (maintenanceMode) {
        <qa-maintenance-mode
          [action]="'start new validations'"
        ></qa-maintenance-mode>
      }
    </div>
    @if (isExistingValidationWindowOpen && isThereValidation) {
      <qa-existing-validation
        [isThereValidation]="isThereValidation"
        (startValidation)="startValidation($event)"
        (closed)="isExistingValidationWindowOpen = false"
      />
    }
  </div>
</main>
<p-scrollTop styleClass="scroll-button"></p-scrollTop>
